if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        setTimeout(() => {
          this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

          this.addEventListener('product-info:loaded', ({ target }) => {
            target.addPreProcessCallback(this.preprocessHTML.bind(this));
          });
        })
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      async show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then(async (responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

           const compareTemplate = opener.getAttribute('data-product-url');
           const isCompareShades = compareTemplate.includes('compare-shades');

            const productElement = responseHTML.querySelector(
              isCompareShades 
              ? 'product-info-compare-shades' 
              : 'product-info, product-info-bundle'
            );
            productElement?.querySelectorAll(".product__media-item--video")?.forEach(el => el.remove());
            
            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
           
            document.dispatchEvent(new CustomEvent('productScript:init'));
            document.dispatchEvent(new CustomEvent('pdp-accordion:init'));


            // const productJsonScript = this.modalContent.querySelector('script[data-productjson]');
            // const productData = JSON.parse(productJsonScript.textContent);
           
            // if (window.trynow && typeof window.trynow.product.recalculateCtaButtonState === 'function') {
            //    const state = await window.trynow.product.recalculateCtaButtonState(productData);
            //    const visibility = await window.trynow.product.calculateProductVisibilityFromTags(productData.tags);
            //   window.trynow.reset();
            //   console.log('createVisibilityRuleset', state, visibility);
            // } else {
            //   console.error('recalculateCtaButtonState function is not defined.');
            // }
           
            
            //===========adjust quickview spacing
            setTimeout(()=> { 
                const infoWrapper = this.querySelector('.product__info-wrapper');
                const buyButtonsWrapper = this.querySelector('.buy_button_new');
                if(infoWrapper && buyButtonsWrapper) {
                   const outerHeight = buyButtonsWrapper.getBoundingClientRect().height;
                  infoWrapper.style.setProperty('padding-bottom', `${outerHeight}px`, 'important');
                } 
            }, 1500);

            
            if(typeof initializeKlaviyoTrigger == 'function') initializeKlaviyoTrigger();

            if(typeof window.initVideowise == 'function') window.initVideowise();
            
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
        
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));


       
      }
    }
  );
}
